import classNames from 'classnames'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import moment from 'moment'

import ProfileOverview from '../ProfileOverview'

import { ReactComponent as ModalXIcon } from '../../../../../../assets/images/common/icons/modal-X-icon.svg'
import classes from './WaitlistViewAllModal.module.scss'
import SubmitButton from '../../../../../common/buttons/SubmitButton'

const WaitlistStudentRow = ({ user: student, createdAt }) => (
  <div className='row mb-3'>
    <div className='col-4 d-flex justify-content-center'>
      <ProfileOverview student={student} />
    </div>
    <div className='col d-flex justify-content-center'>
      {student.email ? (
        <p className='mb-0 font-weight-bold'>{student.email}</p>
      ) : (
        <ul className={classes.multipleValueList}>
          {student.familyAdminsEmails.map((email, idx) => (
            <li key={idx}>
              <p className={classNames(classes.value, 'mb-1')}>{email}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
    <div className='col d-flex justify-content-center'>
      <p className={classes.date}>{moment(createdAt).format('L h:ma')}</p>
    </div>
    <div className='col d-flex justify-content-center'>
      <p className='mb-0'>{student.phone || '+40123032193'}</p>
    </div>
  </div>
)

WaitlistStudentRow.propTypes = {
  user: PropTypes.object,
  createdAt: PropTypes.string,
}

const WaitlistViewAllModal = ({
  isOpen,
  onClose,
  waitlist,
}) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onClose}
    contentLabel='Remove Student From Waitlist Modal'
    className={classNames(classes.waitlistViewAllModalContent)}
  >
    <div id='WaitlistViewAllModal'>
      <div className='animated fadeIn'>
        <div className='d-flex justify-content-between text-align-right mb-4'>
          <div>
            <h6 className={classes.title}>Waitlist ({waitlist.length})</h6>
          </div>
          <ModalXIcon role='button' aria-label='close modal button' onClick={onClose} />
        </div>
        <div className={classes.list}>
          {waitlist.map(({ id, ...attrs }) => <WaitlistStudentRow key={id} {...attrs} />)}
        </div>
        <div className='d-flex justify-content-center'>
          <SubmitButton buttonMessage='Close' onClick={onClose} className={classes.closeButton} />
        </div>
      </div>
    </div>
  </Modal>
)

WaitlistViewAllModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  waitlist: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    createdAt: PropTypes.string,
    user: PropTypes.any,
  })),
}

export default WaitlistViewAllModal
